import script from "./DashboardServices.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardServices.vue?vue&type=script&setup=true&lang=js"

import "./DashboardServices.vue?vue&type=style&index=0&id=cab3d928&lang=scss"

const __exports__ = script;

export default __exports__